import React, { useState } from "react";

function CaterForm({ onAddCater }) {
  const [formData, setFormData] = useState({
    caterName: "",
    caterAddress: "",
    ownerName: "",
    ownerNumber: "",
    employeeName: "",
    employeeNumber: "",
    perDayFoodCost: "",
    email: ""
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      setLoading(true);

      const result = await onAddCater(formData);

      if (result.success) {
        setMessage(result.message || "Cater added successfully");
        setFormData({
          caterName: "",
          caterAddress: "",
          ownerName: "",
          ownerNumber: "",
          employeeName: "",
          employeeNumber: "",
          perDayFoodCost: "",
          email: ""
        });
      } else {
        setError(result.message || "Failed to add cater");
      }
    } catch (error) {
      setError("Unable to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
      <div className="mb-5">
        <h2 className="text-xl font-semibold text-slate-900">Add New Cater</h2>
        <p className="text-sm text-slate-500 mt-1">
          Fill all required details to add a cater.
        </p>
      </div>

      {message && (
        <div className="mb-4 rounded-xl bg-green-50 border border-green-200 text-green-700 px-4 py-3 text-sm font-medium">
          {message}
        </div>
      )}

      {error && (
        <div className="mb-4 rounded-xl bg-red-50 border border-red-200 text-red-700 px-4 py-3 text-sm font-medium">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input name="caterName" value={formData.caterName} onChange={handleChange} placeholder="Cater Name" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input name="caterAddress" value={formData.caterAddress} onChange={handleChange} placeholder="Cater Address" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input name="ownerName" value={formData.ownerName} onChange={handleChange} placeholder="Owner Name" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input name="ownerNumber" value={formData.ownerNumber} onChange={handleChange} placeholder="Owner Number" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input name="employeeName" value={formData.employeeName} onChange={handleChange} placeholder="Employee Name" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input name="employeeNumber" value={formData.employeeNumber} onChange={handleChange} placeholder="Employee Number" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input type="number" name="perDayFoodCost" value={formData.perDayFoodCost} onChange={handleChange} placeholder="Per Day Food Cost" required className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />
        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address (Optional)" className="w-full rounded-xl border border-slate-300 px-4 py-3 outline-none focus:border-blue-500" />

        <div className="md:col-span-2">
          <button
            type="submit"
            disabled={loading}
            className="inline-flex items-center justify-center rounded-xl bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 font-medium transition disabled:opacity-60"
          >
            {loading ? "Saving..." : "Add Cater"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CaterForm;